import {classes, style} from "./doppe-page-cookie-banner-settings-modal.st.css";
import {FlexLayout} from "@wix/devzai-common-client";
import {
    DoppeViewerModalPanel,
    DoppeViewerModalPanelLayout
} from "../../doppe-viewer-modal-panel/doppe-viewer-modal-panel";
import {DoppeViewerModalPanelHeader} from "../../doppe-viewer-modal-panel-header/doppe-viewer-modal-panel-header";
import {DoppeViewerScrollView} from "../../doppe-viewer-scroll-view/doppe-viewer-scroll-view";
import {DoppeViewerModalPanelSection} from "../../doppe-viewer-modal-panel-section/doppe-viewer-modal-panel-section";
import React from "react";
import {
    DoppeViewerHorizontalButton,
    DoppeViewerHorizontalButtonSize
} from "../../doppe-viewer-horizontal-button/doppe-viewer-horizontal-button";
import {DoppeActionWidgetToggleSwitch} from "../../doppe-action-widget-toggle-switch/doppe-action-widget-toggle-switch";
import {useDoppeViewerClientServices} from "../../../client/doppe-user-app/doppe-viewer-client-services";

import {ConsentPreferences, ConsentPreferencesKeys, ConsentPreferencesKeyValues} from "@wix/devzai-utils-dom";
import {assertNotNullable} from "@wix/devzai-utils-common";
import {useDoppeViewerLocales} from "../../../client/doppe-viewer-locales/doppe-viewer-locales";

export const DoppePageCookieBannerSettingsModal = React.memo(function DoppePageCookieBannerSettingsModal (props: DoppePageCookieBannerSettingsModal.Props) {
    const {
        onClose,
        onPartialApprove
    } = props;

    const doppeViewerLocales = useDoppeViewerLocales();
    const cookieConsentManager = assertNotNullable(useDoppeViewerClientServices().doppeViewerAppCookieService.cookieConsentManager);
    const [changes, setChanges] = React.useState<ConsentPreferences>(cookieConsentManager.getCookieConsent());

    const handleCheckboxChange = (checked: boolean, name: ConsentPreferencesKeys) => {
        setChanges({
            ...changes,
            [name]: checked ? 1 : 0,
        });
    };

    const handleSubmit = () => {
        cookieConsentManager.partialApprove(changes);
        onPartialApprove();
        onClose();
    };

    const cookieSettings: {title: string, content:string, cookieSettingsName: ConsentPreferencesKeys, disabled?: boolean}[] = [{
        title: doppeViewerLocales['cookieConsentEssentialTitle'],
        content: doppeViewerLocales['cookieConsentEssentialContent'],
        cookieSettingsName: ConsentPreferencesKeyValues.ess,
        disabled: true,
    },{
        title: doppeViewerLocales['cookieConsentAnalyticsTitle'],
        content: doppeViewerLocales['cookieConsentAnalyticsContent'],
        cookieSettingsName: ConsentPreferencesKeyValues.anl,
    },
        {
            title: doppeViewerLocales['cookieConsentFunctionalTitle'],
            content: doppeViewerLocales['cookieConsentFunctionalContent'],
            cookieSettingsName: ConsentPreferencesKeyValues.func,
        },
        {
            title: doppeViewerLocales['cookieConsentMarketingTitle'],
            content: doppeViewerLocales['cookieConsentMarketingContent'],
            cookieSettingsName: ConsentPreferencesKeyValues.adv,
        }];

    return <DoppeViewerModalPanel
        className={style(classes.modal, FlexLayout.column.default)}
        mobileLayout={DoppeViewerModalPanelLayout.FullScreen}
        desktopLayout={DoppeViewerModalPanelLayout.InnerCentered}
    >
        <DoppeViewerModalPanelHeader
            title={doppeViewerLocales['cookieConsentModalTitle']}
            dismissButtonCallback={() => {
                onClose();
            }}
        />
        <DoppeViewerScrollView
            className={style(classes.scrollView, FlexLayout.fillRemainingVerticalSpace)}
        >
            <DoppeViewerModalPanelSection
                className={style(classes.modalContent, FlexLayout.column.default)}
            >
                <div
                    className={style(classes.modalBody, FlexLayout.column.default)}
                >
                    {
                        cookieSettings.map((cookieSetting, index) => (
                            <div key={index} className={style(classes.policyBlock, FlexLayout.row, FlexLayout.centerContent)}>
                                <div className={style(classes.policyBlockTexts)}>
                                    <div className={style(classes.policyBlockTitle)}>{cookieSetting.title}</div>
                                    <div className={style(classes.policyBlockContent)}>{cookieSetting.content}</div>
                                </div>
                                <div className={style(classes.toggle,{ disabled: cookieSetting.disabled })}>
                                    <DoppeActionWidgetToggleSwitch
                                        disabled={cookieSetting.disabled}
                                        checked={changes[cookieSetting.cookieSettingsName] === 1}
                                        onCheckedChanged={(checked) => handleCheckboxChange(checked, cookieSetting.cookieSettingsName)}
                                    />
                                </div>
                            </div>
                        ))
                    }
                </div>
            </DoppeViewerModalPanelSection>
            <DoppeViewerModalPanelSection
                className={style(classes.modalFooter, FlexLayout.horizontallyJustifyToEnd)}
            >
                <DoppeViewerHorizontalButton size={DoppeViewerHorizontalButtonSize.Small} onClick={handleSubmit} className={style(classes.button)}>
                    {doppeViewerLocales['cookieConsentSettingsSaveButton']}
                </DoppeViewerHorizontalButton>
            </DoppeViewerModalPanelSection>
        </DoppeViewerScrollView>
    </DoppeViewerModalPanel>
});

export namespace DoppePageCookieBannerSettingsModal {

    export interface Props extends React.HTMLAttributes<any> {
        onPartialApprove: () => void;
        onClose: () => void;
    }
}
